import type { RefObject, Ref, RefCallback } from 'react'
import { useMemo } from 'react'

// @see https://github.com/mui/material-ui/blob/a25a365a4c66738f358ecd745bf3727c0ca9d5b6/packages/mui-utils/src/useForkRef/useForkRef.ts

function setRef<T>(
  ref: RefObject<T | null> | RefCallback<T> | null | undefined,
  value: T | null,
): void {
  if (typeof ref === 'function') {
    ref(value)
  } else if (ref) {
    ref.current = value
  }
}

export function useForkRef<T>(
  ...refs: Array<Ref<T> | undefined>
): RefCallback<T> | null {
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null
    }

    return instance => {
      refs.forEach(ref => {
        setRef(ref, instance)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs)
}
